
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { NumericFormat } from "react-number-format"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import komisyonReverseCalculator from "../../../../../helper/priceReverseCalculator"
import priceReverseCalculator from "../../../../../helper/priceReverseCalculator"
import formatConverter from "../../../../../helper/formatConverter"
import { updatePaymentData } from "../../../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    width: 200px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YakitOraniInput = ({data, isRequired, name, labelText}) => {

    const dispatch = useDispatch() 
    const {showErrors, showRequiredPlaces} = useSelector(state => state.addLoad)
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && data.yakitOrani ==="" && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.yakitOrani, showRequiredPlaces, showErrors])



    const handleChange = (e) => {
        const value = e.target.value.replace(/\([^)]*\)/g, '').replace(/[^0-9]/g, '')
        dispatch(updatePaymentData({yakitOrani:value}))
    }
// ((data?.hedefNakliyefiyat && data.yakitDurumu?.value && data?.yakitOrani) && data?.yakitDurumu?.value === 2) ? ` TL     (%${formatConverter(priceReverseCalculator(data.hedefNakliyefiyat, data.yakitDurumu?.value, data.yakitOrani), 0)})` : !data.hedefNakliyefiyat  ? "" : ` (${formatConverter(priceReverseCalculator(data.hedefNakliyefiyat, data.yakitDurumu?.value, data.yakitOrani), 0)} TL)`
//! burada hata var
  return (
    <Container value={data.yakitOrani} radius={"5px"} isError={isError}>
        <NumericFormat type="text" id={"text"} thousandSeparator={'.'} decimalSeparator={','} prefix={data?.yakitDurumu?.value === 1 ? "%" : ""} suffix={data?.yakitDurumu?.value === 2 ? " TL" : ""}  onChange={handleChange} value={data.yakitOrani || ""} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default YakitOraniInput